import { Dialog, DialogContent, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { DialogTitle } from '@radix-ui/react-dialog';
import { Button } from '@/components/ui/button';

export function ModalWarning(props) {
  const { show, onClose, title, description, titleFirstButton = 'Ok', titleSecondButton = 'Cancelar', onSubmitFirstButton, onSubmitSecondButton, isSubmitting = false } = props;

  return (
    <Dialog
      open={show}
      onOpenChange={onClose}
    >
      <DialogContent
        className="text-center"
        onClick={e => e.stopPropagation()}
      >
        <DialogTitle className="text-lg">{title}</DialogTitle>

        <DialogDescription>{description}</DialogDescription>

        <DialogFooter>
          <Button
            fullWidth
            variant="outline"
            onClick={onSubmitFirstButton}
            disabled={isSubmitting}
          >
            {titleFirstButton}
          </Button>
          <Button
            fullWidth
            onClick={onSubmitSecondButton}
            disabled={isSubmitting}
          >
            {titleSecondButton}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
